export const OTHER_PROGRAM_ID = '63987236e76c4670be61fbab4d94b299';